import { render } from "./UserCareer.vue?vue&type=template&id=58c4a95e&scoped=true&ts=true"
import script from "./UserCareer.vue?vue&type=script&lang=ts"
export * from "./UserCareer.vue?vue&type=script&lang=ts"

import "./UserCareer.vue?vue&type=style&index=0&id=58c4a95e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c4a95e"]])

export default __exports__